import { apolloQuery } from '@/lib/apollo';

// Internal Modules
import { getGlobals, getLocale, getToken } from '@/lib';
import type { ApolloQueryResult, QueryOptions } from 'apollo-client';
import type { GetPasskeyEnrollmentContextQuery } from '@/generated/graphql';

export const getPasskeyEnrollmentContext = async (
  queryOptions: QueryOptions,
): Promise<ApolloQueryResult<GetPasskeyEnrollmentContextQuery>> => {
  const unknown = 'UNKNOWN';
  const token = getToken();
  const { device } = getGlobals();
  const { country } = getLocale();
  const { channel = unknown, browserName = unknown, os = unknown } = device;
  // This is hardcoded as weasley application always use this name
  // to get context. If we have a new feature/app, then we should
  // get a new name
  const integrationType = 'XoOnboardingPasskey';
  const response = await apolloQuery({
    variables: {
      browserName,
      channel,
      countryCodeAsString: country,
      integrationType,
      os,
      token,
    },
    ...queryOptions,
  });

  return response;
};
